export default "__VITE_ASSET__5d491429__"